module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "voice"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": "static/images/boss.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "wx",
    attrs: {
      "src": _vm.wx
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('img', {
    staticClass: "audio",
    attrs: {
      "src": _vm.onOff
    },
    on: {
      "click": _vm.play
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.currentAudioTime))])])]), _vm._v(" "), _c('audio', {
    ref: "audio",
    on: {
      "canplay": _vm.getAudioDuration
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.audio
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "title"
  }, [_vm._v("北美精算师点评")]), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("悟空保产品定制理念")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f41b4dd"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Voice.vue
// module id = 637
// module chunks = 1